import { useEffect } from 'react';
import { startSingleTabSession } from '../../_helpers/singleTabSession.helper';
import { accountService } from '../../_services/accounts.service';

export function CustomerSingleTabGuard(params: { children: JSX.Element }) {
    useEffect(() => {
        if (!accountService.isCustomer)
            return;

        return startSingleTabSession(() => {
            accountService.logout('This account is open in another tab.');
        });
    }, []);

    return params.children;
}
